__webpack_require__.p = "/dev/new-favicon/";